"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceGeo2addressResponseSchema = exports.PlaceGeo2addressResponseItemSchema = exports.PlaceGeo2addressParamSchema = void 0;
var zod_1 = require("zod");
exports.PlaceGeo2addressParamSchema = zod_1.z.object({
    latitude: zod_1.z.number(),
    longitude: zod_1.z.number(),
});
exports.PlaceGeo2addressResponseItemSchema = zod_1.z.object({
    address: zod_1.z.string().nullish(),
    addrdetail: zod_1.z.object({
        country: zod_1.z.string().nullish(),
        sido: zod_1.z.string().nullish(),
        sigugun: zod_1.z.string().nullish(),
        dongmyun: zod_1.z.string().nullish(),
        ri: zod_1.z.string().nullish(),
        rest: zod_1.z.string().nullish(), // 지번 or 건물번호
    }),
    isAdmAddress: zod_1.z.boolean().nullish(),
    isRoadAddress: zod_1.z.boolean().nullish(),
    point: zod_1.z.object({
        x: zod_1.z.number().nullish(),
        y: zod_1.z.number().nullish(), // 좌표 - 경도
    }),
});
exports.PlaceGeo2addressResponseSchema = zod_1.z.object({
    geolocation: zod_1.z.object({
        latitude: zod_1.z.string().nullish(),
        longitude: zod_1.z.string().nullish(),
    }),
    items: zod_1.z.object({
        korea: zod_1.z.array(exports.PlaceGeo2addressResponseItemSchema).nullish(),
    }),
});
